export const getStrengthClass = () => {
  const videoGroups = [
    // Workout 1
    [
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_1.mp4?_t=1761925870",
        groupId: 1,
        step: 4,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_2.mp4?_t=1761925887",
        groupId: 1,
        step: 5,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_3.mp4?_t=1761925903",
        groupId: 1,
        step: 6,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_4.mp4?_t=1761925917",
        groupId: 1,
        step: 7,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_5.mp4?_t=1761925934",
        groupId: 1,
        step: 8,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_6.mp4?_t=1761925947",
        groupId: 1,
        step: 9,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_7.mp4?_t=1761925960",
        groupId: 1,
        step: 10,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_8.mp4?_t=1761925979",
        groupId: 1,
        step: 11,
      },
    ],
    // Workout 2
    [
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_9.mp4?_t=1761925993",
        groupId: 2,
        step: 4,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_10.mp4?_t=1761926010",
        groupId: 2,
        step: 5,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_11.mp4?_t=1761926025",
        groupId: 2,
        step: 6,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_12.mp4?_t=1761926040",
        groupId: 2,
        step: 7,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_13.mp4?_t=1761926056",
        groupId: 2,
        step: 8,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_14.mp4?_t=1761926070",
        groupId: 2,
        step: 9,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_15.mp4?_t=1761926086",
        groupId: 2,
        step: 10,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_16.mp4?_t=1761926101",
        groupId: 2,
        step: 11,
      },
    ],
    // Workout 3
    [
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_17.mp4?_t=1764014312",
        groupId: 3,
        step: 4,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_18.mp4?_t=1764014364",
        groupId: 3,
        step: 5,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_19.mp4?_t=1764014414",
        groupId: 3,
        step: 6,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_20.mp4?_t=1764014460",
        groupId: 3,
        step: 7,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_21.mp4?_t=1764014508",
        groupId: 3,
        step: 8,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_22.mp4?_t=1764014563",
        groupId: 3,
        step: 9,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_23.mp4?_t=1764014611",
        groupId: 3,
        step: 10,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_24.mp4?_t=1764014659",
        groupId: 3,
        step: 11,
      },
    ],
    // Workout 4
    [
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_15.mp4?_t=1761926086",
        groupId: 4,
        step: 4,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_25.mp4?_t=1764014719",
        groupId: 4,
        step: 5,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_6.mp4?_t=1761925947",
        groupId: 4,
        step: 6,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_26.mp4?_t=1764014778",
        groupId: 4,
        step: 7,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_27.mp4?_t=1764014831",
        groupId: 4,
        step: 8,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_28.mp4?_t=1764014882",
        groupId: 4,
        step: 9,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_29.mp4?_t=1764014936",
        groupId: 4,
        step: 10,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_30.mp4?_t=1764015001",
        groupId: 4,
        step: 11,
      },
    ],
    // Workout 5
    [
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_31.mp4?_t=1764690498",
        groupId: 5,
        step: 4,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_11.mp4?_t=1761926025",
        groupId: 5,
        step: 5,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_32.mp4?_t=1764690513",
        groupId: 5,
        step: 6,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_33.mp4?_t=1764777006",
        groupId: 5,
        step: 7,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_34.mp4?_t=1764690530",
        groupId: 5,
        step: 8,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_1.mp4?_t=1761925870",
        groupId: 5,
        step: 9,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_35.mp4?_t=1764690545",
        groupId: 5,
        step: 10,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_36.mp4?_t=1764690561",
        groupId: 5,
        step: 11,
      },
    ],
    // Workout 6
    [
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_1.mp4?_t=1761925870",
        groupId: 6,
        step: 4,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_17.mp4?_t=1764014312",
        groupId: 6,
        step: 5,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_37.mp4?_t=1764690579",
        groupId: 6,
        step: 6,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_21.mp4?_t=1764014508",
        groupId: 6,
        step: 7,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_13.mp4?_t=1761926056",
        groupId: 6,
        step: 8,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_19.mp4?_t=1764014414",
        groupId: 6,
        step: 9,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_38.mp4?_t=1764690596",
        groupId: 6,
        step: 10,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_39.mp4?_t=1764690612",
        groupId: 6,
        step: 11,
      },
    ],
    // Workout 7
    [
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_10.mp4?_t=1761926010",
        groupId: 7,
        step: 4,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_40.mp4?_t=1764709832",
        groupId: 7,
        step: 5,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_2.mp4?_t=1761925887",
        groupId: 7,
        step: 6,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_41.mp4?_t=1764709848",
        groupId: 7,
        step: 7,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_30.mp4?_t=1764015001",
        groupId: 7,
        step: 8,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_42.mp4?_t=1764709863",
        groupId: 7,
        step: 9,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_43.mp4?_t=1764709877",
        groupId: 7,
        step: 10,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_5.mp4?_t=1761925934",
        groupId: 7,
        step: 11,
      },
    ],
    // Workout 8
    [
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_29.mp4?_t=1764014936",
        groupId: 8,
        step: 4,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_22.mp4?_t=1764014563",
        groupId: 8,
        step: 5,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_3.mp4?_t=1761925903",
        groupId: 8,
        step: 6,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_44.mp4?_t=1764709894",
        groupId: 8,
        step: 7,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_45.mp4?_t=1764777022",
        groupId: 8,
        step: 8,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_25.mp4?_t=1764014719",
        groupId: 8,
        step: 9,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_46.mp4?_t=1764709910",
        groupId: 8,
        step: 10,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_24.mp4?_t=1764014659",
        groupId: 8,
        step: 11,
      },
    ],
    // Workout 9
    [
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_47.mp4?_t=1764777039",
        groupId: 9,
        step: 4,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_48.mp4?_t=1764777054",
        groupId: 9,
        step: 5,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_49.mp4?_t=1764777072",
        groupId: 9,
        step: 6,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_38.mp4?_t=1764690596",
        groupId: 9,
        step: 7,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_36.mp4?_t=1764690561",
        groupId: 9,
        step: 8,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_35.mp4?_t=1764690545",
        groupId: 9,
        step: 9,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_40.mp4?_t=1764709832",
        groupId: 9,
        step: 10,
      },
      {
        videoLink:
          "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/ILKB_STRENGHT_DRILLS/COMBO_50.mp4?_t=1764777088",
        groupId: 9,
        step: 11,
      },
    ],
  ];

  const today = new Date();
  const dayNumber = Math.floor(today.getTime() / (1000 * 60 * 60 * 24));

  const groupIndex = dayNumber % videoGroups.length;

  // Return the selected array of video objects
  return videoGroups[groupIndex];
};

// Example usage
// const todayVideos = getRotateVideoLinks();
// console.log(todayVideos);
